import explore_image from '@/public/features/explore.webp';
import schedule_4 from '@/public/features/gps_tracking/Accurate Time Tracking.webp';
import app_2 from '@/public/features/gps_tracking/App.webp';
import app_1 from '@/public/features/gps_tracking/App_1.webp';
import schedule_5 from '@/public/features/gps_tracking/Communication Tools.webp';
import schedule_1 from '@/public/features/gps_tracking/Lower Travel Costs.webp';
import bg from '@/public/features/gps_tracking/Main.webp';
import schedule_2 from '@/public/features/gps_tracking/Schedule.webp';
import { CalendarIcon, CardIcon, ToolsIcon, WalletIcon } from '@/public/icons';
import { ArticleType } from '@/types/articles';
import { IRoutePath } from '@/types/router';

const intro = {
  tag: 'Employee GPS Tracking Software',
  description: `With our free GPS employee tracking tool, you can keep track of your team's every step, providing unrivaled monitoring. Monitor locations with ease, assuring efficiency and safety.`,
  imageSrc: bg.src,
  image: bg,
  first_title: 'Track your team',
  second_title: ' from\xa0anywhere,\xa0at any time!',
};

const faq = {
  title: 'FAQ',
  items: [
    {
      title: `How Can I Track My Employees' GPS?`,
      text: `Locate and GPS track where your employees are with Orcatec’s smartphone based GPS tracking app. The employee GPS location tracking app allows you to access accurate location data with easy integration within the current systems.`,
    },
    {
      title: `How Will GPS Employee Tracking Solutions Benefit My Business?`,
      text: `The free employee GPS tracking software can help in improving the efficiency, accountability and safety that comes with GPS tracking. Optimizing routes is going to reduce costs and also improve operational compliance.`,
    },
    {
      title: `Is Orcatec Employee GPS Tracking Software Free?`,
      text: `Orcatec offers a basic version of its free GPS tracking software for employees, which includes core features for effective location monitoring and reporting.`,
    },
    {
      title: `What Devices Support Orcatec's Employee GPS Tracking App?`,
      text: `Orcatec is compatible with most smartphones and tablets, making it accessible for businesses with a mobile workforce.`,
    },
  ],
};

const testimonals = {
  title: 'Client’s Testimonials',
  description: '',
  items: [
    {
      text: `Orcatec has revolutionized our delivery service. The real-time tracking and route optimization have slashed our delivery times and fuel costs. Absolutely indispensable!`,
      name: 'Julia R.',
      position: 'Fleet Manager',
    },
    {
      text: `The user interface is so intuitive! Our team was up and running with Orcatec in no time, and it has made managing our mobile workforce a breeze.`,
      name: 'Mira L.',
      position: 'House Cleaning Company',
    },
    {
      text: `We were struggling with compliance issues in tracking employee hours. Orcatec’s solution made it easy to adhere to labor laws and improved our audit readiness.`,
      name: 'Tom D.',
      position: 'Compliance Officer.',
    },

    {
      text: `Orcatec has revolutionized our delivery service. The real-time tracking and route optimization have slashed our delivery times and fuel costs. Absolutely indispensable!`,
      name: 'Julia R.',
      position: 'Fleet Manager',
    },
    {
      text: `The user interface is so intuitive! Our team was up and running with Orcatec in no time, and it has made managing our mobile workforce a breeze.`,
      name: 'Mira L.',
      position: 'House Cleaning Company',
    },
    {
      text: `We were struggling with compliance issues in tracking employee hours. Orcatec’s solution made it easy to adhere to labor laws and improved our audit readiness.`,
      name: 'Tom D.',
      position: 'Compliance Officer.',
    },
  ],
};

const blog = {
  title: 'Our Blog',
  description: `Welcome to the Orcatec blog, where we look at the newest developments in GPS tracking technology and provide ideas to help you improve your company operations. Discover professional guidance and industry updates right here.`,
};

const bookDemo = {
  title: `Are you ready to transform\xa0your\xa0operations?`,
  description: `Orcatec helps several firms improve their productivity and compliance. Fill out the form below to begin your road to more efficient operations and better team management with our cutting-edge GPS tracking technology.`,
};

const articles = {
  title: `How Does Employee GPS\xa0Tracking\xa0Software\xa0Work?`,
  items: [
    {
      type: ArticleType.VERICAL,
      image: {
        path: schedule_1,
        alt: 'On-Site Proposal Creation',
      },
      list: [],
      href: '#',
      tag: '',
      title: 'Lower Travel Costs',
      text: `GPS tracking can lower driving time by optimizing routes, which will also result in a substantial reduction in fuel spending. This reduces not only the operational costs to businesses but also makes for a greener operation by creating less carbon movement.\n\nFinally, the route optimization feature is especially useful for businesses that have multiple field teams. With this estimator system in place, each team will be able to take the most convenient route to their next location.`,
    },

    {
      type: ArticleType.VERICAL,
      image: {
        path: schedule_2,
        alt: 'Customer management',
      },
      list: [],
      href: '#',
      tag: '',
      title: 'Quick and Efficient Scheduling',
      text: `Knowing the exact location of each worker enables managers to make actionable decisions on creating assignments and where jobs should fall on their schedules.\n\nThis feature of our GPS employee tracking tool will definitely cut down on idle time, improve your efficiency, and streamline the process of daily routine from multiple job projects.`,
    },

    /* {
      type: ArticleType.HORIZONTAL,
      image: {
        path: schedule_3,
        alt: 'Streamlined Approval Process',
      },
      list: [],
      href: '#',
      tag: '',
      title: `Customizable and Personalized\xa0Proposals`,
      text: `At the core of the software's functionality is its ability to produce highly customizable and personalized proposals. You can tailor every aspect of the proposal, from headers and layouts to itemized or total pricing, ensuring that each proposal reflects the unique value proposition you offer to the client.\n\nThis level of personalization helps to create a connection with the client and demonstrates a deep understanding of their needs.`,
    }, */
    {
      type: ArticleType.VERICAL,
      image: {
        path: schedule_5,
        alt: 'Customer management',
      },
      list: [],
      href: '#',
      tag: '',
      title: 'Real-time Progress and\xa0Productivity Tracking',
      text: `This employee GPS tracking app is a great tool for managers who wish to track their workers’ where-about and work progress during working hours. Real time tracking enables quick identification of bottlenecks and inefficiencies to make necessary immediate changes whenever required. On a regular basis to help keep jobs focused on and work at maximum productivity.`,
    },
    {
      type: ArticleType.VERICAL,
      image: {
        path: schedule_4,
        alt: 'Customer management',
      },
      list: [],
      href: '#',
      tag: '',
      title: 'Clock-In and Clock-Out Times\xa0at\xa0Specific',
      text: `Employee location tracking system free logs the exact times and places for every employee’s clock-in and clock-out feature. This is essential to providing proper payroll processing and remaining respectful of federal, state, or local labor laws. It also prevents time stealing and confirms employees are at the right place during their hours of work.`,
    },
  ],
};

const fullArticle1 = {
  image: {
    path: app_1,
    alt: `Why Orcatec is Right For You?`,
  },
  title: `Why Orcatec is\xa0Right\xa0For\xa0You?`,
  description: `The industry of employee monitoring solutions has a range of products. Orcatec GPS tracking software rises above the rest for being more precise and stable than its competitors in addition to retaining user-friendliness. Orcatec isn’t another tool; it’s a employee GPS tracking solution that integrates with your operations, making them better and more efficient so you can accomplish your goals using: `,
  item: [
    {
      title: 'Precision Tracking',
      description:
        'Having Orcatec’s advanced GPS technology allows critical location data to be provided, so owners can use the most accurate information when making essential operational decisions. Whether you are monitoring a single vehicle or fleet we strive to deliver accurate real-time data',
    },
    {
      title: 'Cost-Effective Operations',
      description:
        'Orcatec can also trim operational expenses by ensuring that routes are optimized and discouraging unnecessary fuel expenditures or excess idling. This makes our software an important tool to reduce not only operating costs but also increase the overall efficiency of your processes, and hence is both economic and ecological',
    },
    {
      title: 'Dedicated Support',
      description: `These are amazing stats and validation for the service department on their excellent customer service. We’re here to assist in helping you implement our system as easily into your process as possible and continue the support after that to help you maximize what we have built.`,
    },
  ],
};

const fullArticle2 = {
  image: {
    path: app_2,
    alt: `What Is Employee GPS Tracking Software?`,
  },
  title: `What Is Employee GPS Tracking\xa0Software?`,
  description: `Employee GPS tracking software is a type of technology that allows enterprises to monitor where their employees are at any given time via GPS (Global Positioning System).\n\nIt is widely used to control field operations, minimize logistics, and implement the security of employees by capturing movement of what they are doing during working hours. It can be integrated into mobile devices or vehicles and often comes with features for route optimization, geofencing, time tracking, and reporting.`,
  item: [
    {
      title: '',
      description:
        'Streamlines field operations and reduces travel time through route optimization.',
    },
    {
      title: '',
      description:
        'Verifies employee locations and activities, fostering transparency and reliability',
    },

    {
      title: '',
      description: `Monitors employees in real-time, enhancing safety measures for field personnel.`,
    },
  ],
};

const explore = {
  title: 'Explore More ',
  subtitle: 'Tools For Job Success',
  description: `Dive into a wealth of insights tailored to your industry with Orcatec's blog, your go-to resource 
  for the latest trends and tips in service scheduling software free`,
  image: explore_image,
  items: [
    {
      title: 'Complete Job & Invoice',
      path: IRoutePath.FEATURES_INVOICING,
      icon: WalletIcon,
      items: [
        {
          title: 'Sales Proposal Tool',
          path: '',
        },

        {
          title: 'Invoicing',
          path: '',
        },
        {
          title: 'Estimates',
          path: '',
        },
        {
          title: 'Quoting',
          path: '',
        },
      ],
    },
    {
      title: 'Scheduling & Dispatching',
      path: IRoutePath.FEATURES_SCHEDULIG,
      icon: CalendarIcon,
      items: [
        {
          title: 'Employee GPS Tracking',
          path: '',
        },
        {
          title: 'Scheduling Software',
          path: '',
        },
        {
          title: 'Route Optimization',
          path: '',
        },
        {
          title: 'Field Service App',
          path: '',
        },
        {
          title: 'Voice Solutions',
          path: '',
        },
        {
          title: 'Dispatching',
          path: '',
        },
      ],
    },
    {
      title: 'Get Paid & Expenses',
      path: IRoutePath.FEATURES,
      icon: CardIcon,
      items: [
        {
          title: 'Commissions Management',
          path: '',
        },
        {
          title: 'Home Services Marketing',
          path: '',
        },
        {
          title: 'Automated Direct Mail',
          path: '',
        },
        {
          title: 'Consumer Financing',
          path: '',
        },
        {
          title: 'Advanced Reporting',
          path: '',
        },
        {
          title: 'Expenses Tracking',
          path: '',
        },

        {
          title: 'Contractor Payroll',
          path: '',
        },
        {
          title: 'Card Reader',
          path: '',
        },
      ],
    },
    {
      title: 'Job Management',
      icon: ToolsIcon,
      path: IRoutePath.FEATURES,
      items: [
        {
          title: 'Work Order Management',
          path: '',
        },
        {
          title: 'Field Service CRM',
          path: '',
        },
        {
          title: 'Job Management',
          path: '',
        },
        {
          title: 'Job Tracking',
          path: '',
        },
        {
          title: 'Job Costing',
          path: '',
        },
      ],
    },
  ],
};

export {
  articles,
  blog,
  bookDemo,
  faq,
  fullArticle1,
  fullArticle2,
  intro,
  testimonals,
  explore,
};
